//格式化时间
Date.prototype.Format = function (fmt) {
    const o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (const k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

//调用
export const timeStr = new Date().Format("yyyyMMddHHmmss");

export function timefilters(date){
    // return new Date(date).Format("yyyy-MM-dd HH:mm:ss");
    if(date==null){
        return ""
    }
    if(date instanceof Date) {
        return date.Format("yyyy-MM-dd HH:mm:ss");
    }else if(isNaN(date)==0){
        return new Date(date).Format("yyyy-MM-dd HH:mm:ss");
    }else{
        if(date.indexOf('T')!=-1){
            return date.slice(0,19).replace('T',' ')
        }else{
            return new Date(date.replace(/-/g,'/')).Format("yyyy-MM-dd HH:mm:ss");
        }
    }
}